import React, { useState, useEffect } from 'react';
import { Row, Col, Button, ModalHeader, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import FormDropzone from '../ReactHookFormCustom/FormDropzone';
import { addDocumentToTheApplicant } from '../../Services/applicantService';
import { SpinnerLoaderModal } from '../shared/SpinnerLoaderModal';

const AddDocumentModal = ({ isOpen, toggle, id, onStatusRefresh }) => {
  const { handleSubmit, control, setValue, reset } = useForm({});
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmitWithValidations = (values) => {
    setIsLoading(true);

    addDocumentToTheApplicant({ ...values, id })
      .then((result) => {
        onStatusRefresh && onStatusRefresh();
      })
      .finally(() => {
        setIsLoading(false);
        toggle();
      });
  };

  useEffect(() => {
    if (!isOpen) {
      reset();
    }
  }, [isOpen, reset]);

  const saveDocument = () => {
    handleSubmit(handleSubmitWithValidations)();
  };

  const onError = (errors) => {
    const firstErrorKey = Object.keys(errors)[0];
    const errorElement = document.querySelector(`[name="${firstErrorKey}"]`);
    if (errorElement && typeof errorElement.focus === 'function') {
      errorElement.focus();
    } else {
      console.error(`Element with name "${firstErrorKey}" not found or cannot be focused.`);
    }
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitWithValidations, onError)}>
      <Modal isOpen={isOpen} centered>
        <ModalHeader>Add new Document</ModalHeader>
        <ModalBody>
          <Row className="align-items-center justify-content-center">
            <Col>
              {/* {isLoading ? (
                <SpinnerLoaderModal />
              ) : ( */}
              <FormDropzone
                control={control}
                name="document"
                id="documentId"
                text="Insert Document"
                setValue={setValue}
                rules={{ required: t('common.REQUIRED') }}
              />
              {/* )} */}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={saveDocument} disabled={isLoading}>
            {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
            &nbsp;{t('common.SAVE')}
          </Button>
          <Button color="secondary" onClick={toggle}>
            {t('common.CANCEL')}
          </Button>
        </ModalFooter>
      </Modal>
    </form>
  );
};

export default AddDocumentModal;
